import { CommonModule } from "@angular/common";
import { Component, computed, input, ChangeDetectionStrategy } from "@angular/core";
import { CalendarData } from "../../modules/home/calendar/CalendarData";
import { S25PipesModule } from "../../pipes/s25.pipes.module";
import { UserprefService } from "../../services/userpref.service";
import { s25Resource } from "../../util/s25.resource";
import { S25Util } from "../../util/s25-util";

@Component({
    selector: "s25-ng-calendar-reservation-date-range",
    standalone: true,
    imports: [CommonModule, S25PipesModule],
    host: {
        class: "eventTime",
    },
    template: `
        @if (startsOnDiffDay() && addtlDiffDay() && !rsrvDiffDay()) {
            <span class="meridiem ngFulldate fulldateStart">
                {{ reservation().rsrv_start_dt | dateFormat: dateFormat.value() }}
            </span>
        }
        <span class="startDt">
            {{ reservation().rsrv_start_dt | timeFormat: timeFormat.value() }}
        </span>
        @if (rsrvDiffDay()) {
            <span class="meridiem ngFulldate fulldateStart">
                {{ reservation().rsrv_start_dt | dateFormat: dateFormat.value() }}
            </span>
        }
        <span class="meridiem"> - </span>
        <span class="endDt">{{ reservation().rsrv_end_dt | timeFormat: timeFormat.value() }}</span>
        @if (rsrvDiffDay()) {
            <span class="meridiem ngFulldate fulldateEnd">
                {{ reservation().rsrv_end_dt | dateFormat: dateFormat.value() }}
            </span>
        }
        @if (reservation().addtl_start_dt || reservation().addtl_end_dt) {
            <br />
            @if (reservation().addtl_start_dt) {
                <span class="startDt">( {{ reservation().addtl_start_dt | timeFormat: timeFormat.value() }}</span>
                @if (addtlDiffDay()) {
                    <span class="meridiem ngFulldate fulldateStart">
                        {{ reservation().addtl_start_dt | dateFormat: dateFormat.value() }}
                    </span>
                }
                <span class="meridiem"> - </span>
            }
            @if (reservation().addtl_end_dt) {
                <span class="endDt">{{ reservation().addtl_end_dt | timeFormat: timeFormat.value() }} )</span>
                @if (addtlDiffDay()) {
                    <span class="meridiem ngFulldate fulldateEnd">
                        {{ reservation().addtl_end_dt | dateFormat: dateFormat.value() }}
                    </span>
                }
            }
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: `
        .ngFulldate {
            font-size: x-small;
            white-space: nowrap;
        }
    `,
})
export class CalendarReservationDateRange {
    readonly reservation = input.required<CalendarData.Reservation>();

    readonly startsOnDiffDay = computed(
        () => !S25Util.date.equalDate(this.reservation().calendar_date, this.reservation().rsrv_start_dt),
    );
    readonly rsrvDiffDay = computed(
        () => !S25Util.date.equalDate(this.reservation().rsrv_start_dt, this.reservation().rsrv_end_dt),
    );
    readonly addtlDiffDay = computed(
        () =>
            S25Util.isDefined(this.reservation().addtl_start_dt) &&
            !S25Util.date.equalDate(this.reservation().addtl_start_dt, this.reservation().addtl_end_dt),
    );

    readonly dateFormat = s25Resource({ loader: () => UserprefService.getS25Dateformat(), defaultValue: "MM/dd/yyyy" });
    readonly timeFormat = s25Resource({ loader: () => UserprefService.getS25Timeformat(), defaultValue: "hh:mm a" });

    protected readonly Reservation = CalendarData.Reservation;
}
